import { addComma } from "./addComma";

export const commaMaskedInputHelper = {
  mask(input: string): string {
    return addComma(this.unMask(input), "");
  },
  unMask(input: string): string {
    return String(input).replace(/,/g, "");
  },
};
